import { app } from '../../../../../app';
import { Controller } from './idp-authenticator-applications.controller';

app.component('companyIdpAuthenticatorsManageApplications', {
    bindings: {
        companyId: '<',
        idpAuthenticator: '<',
        applications: '<',
    },
    controller: Controller,
    templateUrl: require('./idp-authenticator-applications.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/applications/idp-authenticator-applications.component.js